const f = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
function t(a) {
  return f.test(a);
}
export {
  t as isValidUuid
};
//# sourceMappingURL=helpers.mjs.map
